import { mutationOptions } from '@tanstack/react-query';
import { queryClient } from 'merchant-api';
import { unifiedApiClient } from './client';

interface SubmitAppRequest {
  applicationId: string;
}

export type SubmitAuth =
  | { action: 'none' }
  | { action: 'otp_required'; key: string; emailMasked: string; redirect: string };

// Single submit: the backend associates the caller to the application (find/create user +
// ownership write) and kicks off decisioning in the same call. The decision outcome is never
// in the response - AppReview polls the application status for it (decisionStatus below is
// best-effort only). On `otp_required` Butterfly is NOT called (it only accepts the owner's
// credential): applicationStatus stays pre-submit (e.g. STARTED) and the caller must submit
// again after OTP verification to run the real submit sequence.
interface SubmitAppResponse {
  applicationId: string;
  applicationStatus: string;
  auth: SubmitAuth;
  decisionStatus?: string;
}

const submitApp = async ({ applicationId }: SubmitAppRequest, headers?: Record<string, string>) => {
  const { data } = await unifiedApiClient.POST('/client/application/v1/{applicationId}/submit', {
    params: { path: { applicationId } },
    headers,
  });
  queryClient.invalidateQueries({ queryKey: ['app'] });
  return data as unknown as SubmitAppResponse;
};


interface SubmitAppOptsParams {
  // Called on every attempt (including retries), so single-use values such as a captcha token are fresh.
  getHeaders?: () => Promise<Record<string, string>>;
}

export const submitAppOpts = ({ getHeaders }: SubmitAppOptsParams = {}) =>
  mutationOptions<SubmitAppResponse, Error, SubmitAppRequest>({
    mutationFn: async (request) => submitApp(request, await getHeaders?.()),
  });

export default submitApp;
